import styled, { css } from 'styled-components';
import { injectTypography } from '../../utils/injectTypography';
import { injectInteractionBar } from '../../utils/injectInteractionBar';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { getEasing } from '../../utils/getEasing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
export const StyledContainer = styled.div `
  --iconsize: 24px;
  --padding-inline: calc(
    var(${(props) => props.theme.responsive.spacing.s}) + var(--iconsize)
  );

  ${injectSpacing('margin')}
`;
export const StyledInnerContainer = styled.div `
  display: grid;
  grid-template-columns: [search-icon] 24px [input] 1fr [clear-icon] 24px [end];
  align-items: center;

  ${(props) => injectInteractionBar(props)}

  &::after {
    grid-column: search-icon / end;
  }
`;
const injectFieldLayout = css `
  display: block;
  grid-row: 1;
  grid-column: search-icon / end;

  margin: 0;
  padding: 0;
  padding-inline-start: var(--padding-inline);
  padding-inline-end: var(--padding-inline);
  padding-block-start: var(${(props) => props.theme.responsive.spacing.xxs});
  padding-block-end: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledLabel = styled.label `
  ${injectFieldLayout}

  ${(props) => injectTypography(props, 'copy1')}

  color: ${(props) => props.theme.colors.form.secondary};

  opacity: 1;

  transition-timing-function: ${getEasing};
  transition-duration: 0.25s;
  transition-property: color, opacity;

  pointer-events: none;

  ${injectOSXFontSmoothing(true)}

  *:focus-within > & {
    opacity: 0;
  }

  ${(props) => props.disabled &&
    css `
      color: ${(props) => props.theme.colors.form.secondary};

      cursor: not-allowed;
    `}

  ${(props) => !props.empty &&
    css `
      opacity: 0;
    `}
`;
export const StyledInput = styled.input `
  all: revert;

  color: ${(props) => props.theme.colors.form.primary};

  ${injectFieldLayout}

  ${(props) => injectTypography(props, 'copy1')}


  background-color: transparent;
  border: 0;

  transition: color 0.25s ${getEasing};

  appearance: none;

  ${injectOSXFontSmoothing(true)}

  &:hover {
    color: ${(props) => props.theme.colors.form.strong};
  }

  &:disabled {
    color: ${(props) => props.theme.colors.form.muted.primary};

    cursor: not-allowed;
  }

  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    display: none;
  }
`;
export const StyledIcon = styled.svg `
  all: revert;

  display: block;
  width: var(--iconsize);
  height: var(--iconsize);

  color: ${(props) => props.disabled && props.theme.colors.form.muted.primary};

  pointer-events: none;
`;
export const StyledSearchIconContainer = styled.span `
  grid-row: 1;
  grid-column: search-icon;
`;
export const StyledClearButton = styled.button `
  all: revert;

  display: block;

  grid-row: 1;
  grid-column: clear-icon;

  width: var(--iconsize);
  height: var(--iconsize);

  padding: 0;

  background: transparent;
  border: none;

  cursor: pointer;
`;
//# sourceMappingURL=Search.styles.js.map